import Handsontable from "handsontable";

export class KeyValueListEditor extends Handsontable.editors.HandsontableEditor {
  private htOptions: any;

  override prepare(
    row,
    col,
    prop,
    td,
    value,
    cellProperties
  ) {
    super.prepare(row, col, prop, td, value, cellProperties);

    Object.assign(this.htOptions, {
      licenseKey: 'non-commercial-and-evaluation',
      data: this.cellProperties.source,
      columns: [
        {
          data: 'value',
        },
        {
          data: 'key',
        },
      ],
      hiddenColumns: {
        columns: [1],
      },
      trimDropdown: false,
      height: 100,
      width: '150px',
      colWidths: '300px',
      beforeValueRender(
        value,
        {row, instance}
      ) {
        return instance.getDataAtRowProp(row, 'key');
      },
    });

    if (cellProperties.keyValueListCells) {
      this.htOptions.cells = cellProperties.keyValueListCells;
    }
    if (this.htEditor) {
      this.htEditor.destroy();
    }

    this.htEditor = new Handsontable(this.htContainer, this.htOptions);
  }

  override setValue(value) {
    if (this.htEditor) {
      const index = this.htEditor.getDataAtProp('value').findIndex(id => id === value);

      if (index !== -1) {
        value = this.htEditor.getDataAtRowProp(index, 'key');
      }
    }
    super.setValue(value);
  }

  override getValue() {
    const value = super.getValue();

    if (this.htEditor) {
      const labels = this.htEditor.getDataAtProp('key');
      const row = labels.indexOf(value);

      if (row !== -1) {
        return this.htEditor.getDataAtRowProp(row, 'value');
      }
    }

    return value;
  }
}

const keyValueListValidator = function (
  value,
  callback
) {
  callback(true);
};

const keyValueListRenderer = function (
  hot,
  TD,
  row,
  col,
  prop,
  valueCell,
  cellProperties
) {
  const item = cellProperties.source.find(value => value.value === valueCell);

  if (item) {
    valueCell = item.key;
  }

  Handsontable.renderers.AutocompleteRenderer(hot, TD, row, col, prop, valueCell, cellProperties);
};

Handsontable.cellTypes.registerCellType('key-value-list', {
  editor: KeyValueListEditor,
  validator: keyValueListValidator,
  renderer: keyValueListRenderer,
});
